import { Attribute } from '@gn-audio/jss-core';

export type ECommercePayload = {
  event: ECommerceEventTypes;
  ecommerce: ECommerceData;
};

export type ECommerceData = {
  currency: string;
  coupon?: string;
  items: ECommerceItems[];
};

export type ECommerceItems = {
  item_name: string;
  item_id: string;
  price: string | number;
  item_brand: string | Attribute;
  item_category: string | Attribute;
  quantity: string | number;
  currency: string;
};

export enum ECommerceEventTypes {
  view_item = 'view_item',
  add_to_cart = 'add_to_cart',
  remove_from_cart = 'remove_from_cart',
  view_cart = 'view_cart',
  begin_checkout = 'begin_checkout',
  login_checkout = 'login_checkout',
}
